import {
  Show,
  List,
  TabbedShowLayout,
  Tab,
  Datagrid,
  BooleanField,
  EditButton,
  TextField,
  ReferenceField,
  ReferenceManyField,
  DateField,
  TopToolbar,
  RefreshButton,
  ListButton,
  ExportButton,
  useRecordContext,
  usePermissions,
  useGetOne,
  useResourceContext,
  useTranslate,
} from "react-admin";
import React, { cloneElement, useEffect, useState } from "react";
import { CamelCaseField, ExpectedDateField } from "../digitalOrders/common";
import { Scrollbars } from "react-custom-scrollbars";
import {
  getLocalStorageKey,
  CommonHeaderOption,
  RUN_TIME_API_ENDPOINT,
} from "../common/common";
import Swal from "sweetalert2";
import GetAppIcon from "@mui/icons-material/GetApp";
import { useLocation } from "react-router-dom";

// const topToolbarStyle = {
//     zIndex: 2,
//     display: 'inline-block',
//     float: 'right',
// };

const ShowActions = () => {
  const resource = useResourceContext();
  const record = useRecordContext();
  const { data } = useGetOne("in_app_notifications", { id: record?.id });

  const callExport = (e) => {
    const options = CommonHeaderOption();
    const apiUrl = RUN_TIME_API_ENDPOINT;
    e.preventDefault();
    options.method = "GET";
    fetch(`${apiUrl}/${resource}_for_sdo_csv/${data.id}`, options)
      .then((res) => {
        return res.json();
      })
      .then((jsonD) => {
        console.log("json= inside callback", jsonD.data);
        const msg = jsonD.data ? jsonD.data[0].message : "";
        Swal.fire({
          html: msg,
          icon: "success",
        });
      });
  };

  // const { data, resource, filterValues, total, maxResults, currentSort, exporter, permanentFilter, showFilter, displayedFilters, filters, basePath } = this.props;
  const csvResource = "empty_data";
  return (
    <React.Fragment>
      <TopToolbar>
        <RefreshButton />
        <ListButton basePath={resource} />
        {/* <ExportButton
                        onClick={e => callExport(e, data)}
                        disabled={total === 0}
                        sort={data && data.created_at}
                        resource={csvResource}
                    /> */}
        <div>
          <button
            className="export-button"
            onClick={(e) => callExport(e)}
            // disabled={total === 0}
            sort={data && data.created_at}
          >
            {<GetAppIcon />}
            <span>Export</span>
          </button>
        </div>
      </TopToolbar>
    </React.Fragment>
  );
};

const ShowTitle = () => {
  const record = useRecordContext();
  console.log("record.name", record);
  return record && <span>Send Bulk Notification {record.name}</span>;
};

const BulkInAppNotificationShow = (props) => {
  const [loadingShow, setLoadingShow] = useState(false);

  const permissions = usePermissions();
  const record = useRecordContext();
  const translate = useTranslate();
  const location = useLocation();
  const pathSplit = location.pathname.split("/");
  const bulkInAppNotificationId = pathSplit[2];

  // const { props, permissions, state } = this;
  // console.log('xxxx', state.soldToList);
  return (
    <Show
      actions={<ShowActions permissions={permissions} />}
      title={<ShowTitle />}
    >
      <TabbedShowLayout className="tab-scroll">
        <Tab
          label={translate("Details")}
          sort={{ field: "created_at", order: "DESC" }}
          contentClassName="scrollTab"
        >
          <TextField source="purpose" allowEmpty />
          <TextField source="job_status" />
          <TextField source="admin_name" />
          <TextField source="admin_email" />
          <TextField source="targeted_businesses_count" allowEmpty />
          <TextField source="notified_businesses_count" allowEmpty />
          <TextField source="notification_read_count" allowEmpty />
          <TextField source="send_status_percent" allowEmpty />
          {/* <DateField label={'Created at'} source="created_at" allowEmpty /> */}
          <DateField source="created_at" showTime />
        </Tab>
        <Tab label={translate("Sold To List")}>
          <ReferenceManyField
            label=""
            reference="bulk_notification_sold_to_list"
            target="id"
            className="tab-pagination"
          >
            <List
              filterDefaultValues={{ id: bulkInAppNotificationId }}
              hasCreate={false}
              exporter={false}
              actions={false}
            >
              <Datagrid className="tab-data-grid" bulkActionButtons={false}>
                <TextField source="name" />
                <TextField source="title" allowEmpty />
                <BooleanField sortable={false} source="notification_status" />
                <BooleanField source="read_status" />
                <DateField source="notification_sent_at" />
              </Datagrid>
            </List>
          </ReferenceManyField>
        </Tab>
      </TabbedShowLayout>
    </Show>
  );
};
export default BulkInAppNotificationShow;
